export default __webpack_public_path__ + "static/media/kedanjia.36ffd890.png";